import Swiper from "swiper";
import Navigation from "swiper/modules/navigation.mjs";
import Pagination from "swiper/modules/pagination.mjs";
import Thumbs from "swiper/modules/thumbs.mjs";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".swiper-element-slider").forEach((swiper) => {
    var sliderId = swiper.parentNode.getAttribute("data-slider-id");
    var paginationEl = swiper
      .closest('.element-slider[data-slider-id="' + sliderId + '"]')
      .querySelector(".swiper-pagination");
    var prevEl = swiper
      .closest('.element-slider[data-slider-id="' + sliderId + '"]')
      .querySelector(".swiper-button-prev");
    var nextEl = swiper
      .closest('.element-slider[data-slider-id="' + sliderId + '"]')
      .querySelector(".swiper-button-next");
    var thumbsEl = swiper
      .closest('.element-slider[data-slider-id="' + sliderId + '"]')
      .querySelector(".swiper-element-thumbs");

    if (!paginationEl || !prevEl || !nextEl || !thumbsEl) {
      return;
    }

    var thumbsSwiper = new Swiper(thumbsEl, {
      spaceBetween: 8,
      slidesPerView: 2,
      freeMode: false,
      autoHeight: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
      },
    });

    new Swiper(swiper, {
      modules: [Navigation, Pagination, Thumbs],
      speed: 400,
      spaceBetween: 8,
      slidesPerView: "auto",
      autoHeight: true,
      cssWidthAndHeight: false,
      visibilityFullFit: false,
      autoResize: false,
      cssMode: false,
      breakpoints: {
        640: {
          spaceBetween: 8,
        },
        1024: {
          spaceBetween: 16,
        },
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  });
});
